module.exports = __webpack_public_path__ + "img/patient-record-desktop-fr.05a8c01d.jpg";